import React, { useState, useEffect } from 'react';
import BasicCard from '../../../components/basics/cards/BasicCard';
import FilterSettingsSettings from '../../../components/FilterSettings'
import ReportDownload from '../../../components/ReportDownload'



import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { CommonAPIService } from "../../../services/apis/CommonAPIService";

export default function DataCorrections() {
    const [updatingFilter, setUpdatingFilter] = useState(false)
    const [filterArray, setFilterArray] = useState(0)
    const [downloadOptions, setDownloadOptions] = useState({})
    const [hasDownload, setHasDownload] = useState(true);
    const [selectedDownloadItems, setSelectedDownloadItems] = useState([])

    const downloadConfig = {
        idName: '',
        excelFileName: 'CorrectionTemplate.xlsx'
    }


    const [pageConfig, setPageConfig] = useState({
        controllerName: "DataCorrections",
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        parameters: "",
    })
    useEffect(() => {
        CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${pageConfig.controllerName}/PageSettings`)
            .then(data => setPageConfig({ ...pageConfig, ...{ pageSettings: data } }))
            .catch(error => console.error(error));
    }, [pageConfig.apiName, pageConfig.controllerName]);

    useEffect(() => {
        setDownloadOptions({ hasDownload: true, selectedDownloadItems: selectedDownloadItems, setSelectedDownloadItems: setSelectedDownloadItems })
    }, [hasDownload, selectedDownloadItems])
    

    return (
        <BasicCard cardConfig={{ cardTitle: 'Data corrections', cardHeadingElement: 'h4' }}>
            <Tabs defaultActiveKey='download' id='DataCorrections-tabs' className='mb-3'>
                <Tab eventKey='download' title='Download correction'>
                    <BasicCard cardConfig={{ cardTitle: '', cardHeadingElement: 'h4' }}>
                        <FilterSettingsSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} /> 
                        <ReportDownload pageConfig={pageConfig} filterArray={filterArray} downloadConfig={downloadConfig} downloadItems={selectedDownloadItems} />         
                    </BasicCard>
                </Tab>
            </Tabs>
        </BasicCard>
    );
}
